import { WarningOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export default function NotImplemented({ label, small }: { label: string; small?: boolean }) {
  const fontSize = small ? 8 : 14;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 1,
        border: '1px dashed rgba(0, 0, 0, 0.2)',
      }}
    >
      <WarningOutlined sx={{ fontSize: fontSize + 5 }} color="disabled" />
      <Typography
        variant="h6"
        sx={{
          color: 'text.disabled',
          textAlign: 'center',
          fontWeight: 'medium',
          fontSize,
        }}
      >
        Not implemented
      </Typography>
      {!small && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.disabled',
            textAlign: 'center',
            mt: 1,
            fontSize,
          }}
        >
          section{' '}
          <Box component="span" sx={{ fontWeight: 'bold' }}>
            {label}
          </Box>{' '}
          is not implemented yet
        </Typography>
      )}
    </Box>
  );
}
